module.exports = "<listado-general \r\n[listado]=\"channels\" \r\n[titulo]=\"'Channels' | i18next\" \r\n[urladicional]=\"'/home'\" \r\n[leyendaListado]=\"'DEFAULT_LEYENDA_HOME' | i18next\">\r\n</listado-general>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/sistema.component.html
// module id = ../../../../../src/app/private/configuracion/sistema.component.html
// module chunks = main